var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toTop",on:{"click":_vm.toTopFun}},[_vm._v(_vm._s(_vm.toTopMsg))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-741af2fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/tobuttontop.vue
// module id = G2Bf
// module chunks = 0